export const MIN_BOUNDING_BOX_WIDTH = 1;
export const MIN_BOUNDING_BOX_HEIGHT = 1;



// WEBPACK FOOTER //
// ./src/components/workspace/objects/constants.ts